///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Route } from '@angular/router';
import { HomeComponent } from './home.component';

export const HOME_ROUTE: Route = {
    path: '',
    component: HomeComponent,
    data: {
        authorities: [],
        pageTitle: 'home.title'
    }
};
